// Entry point / main function

var AuthManager = require('./authmanager');

window.CVP.AuthManager = AuthManager;

module.exports = AuthManager;
